import styled from 'styled-components';

export const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border: none;
  background: none;
  color: #757575;
  font-size: 0.85rem;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1rem;

  &:hover {
    color: #282828;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0.25rem;
`;

export const CompanyLogo = styled.img`
  height: 48px;
  width: auto;
  border-radius: 4px;
  object-fit: contain;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
`;

export const ConfigLine = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: #757575;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
`;

export const ColorSwatch = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color || '#ccc'};
  border: 1px solid rgba(0, 0, 0, 0.1);
  vertical-align: middle;
`;

export const EditNotice = styled.span`
  font-size: 0.75rem;
  color: #bdbdbd;
  font-style: italic;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  align-items: center;
  margin: 1.5rem 0 1rem;
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export const StatCard = styled.div`
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background-color: ${(props) => props.bg || '#f5f5f5'};
  color: ${(props) => props.color || '#616161'};
  font-size: 0.8rem;
  min-width: 96px;
  text-align: center;

  strong {
    display: block;
    font-size: 1.25rem;
    line-height: 1.4;
  }
`;

export const ProgressWrapper = styled.div`
  margin-bottom: 1rem;
`;

export const ProgressLabel = styled.div`
  font-size: 0.8rem;
  color: #757575;
  margin-bottom: 0.35rem;
`;

export const ErrorMessage = styled.div`
  font-size: 0.75rem;
  color: #c62828;
  margin-top: 0.15rem;
`;

export const EmailSentHint = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.75rem;
  color: #2e7d32;
  margin-left: 0.5rem;
  white-space: nowrap;
`;

export const CertLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
`;

export const LoadingWrapper = styled.div`
  padding: 3rem;
  text-align: center;
  color: #888;
`;

export const LoadErrorWrapper = styled.div`
  padding: 3rem;
  text-align: center;
  color: #757575;

  p {
    margin: 0 0 1rem;
    font-size: 0.95rem;
  }
`;
